module.exports = __webpack_public_path__ + "static/media/money3.e1d221e4.jpg";